import { useState } from 'react';

const faqs = [
  {
    question: '三上悠亞的最新作品在哪裡可以看到？',
    answer: '三上悠亞的最新作品資訊可在本網站的作品分類頁面中查詢，我們會在第一時間更新她的最新發行資訊與上線平台。您也可以訂閱我們的電子報，不錯過任何更新。',
  },
  {
    question: '如何購買三上悠亞的寫真集？',
    answer: '三上悠亞的寫真集可於日本各大線上書店（如 Amazon Japan、Rakuten Books）及實體書店購買。部分寫真集也提供海外配送服務，建議您查詢各通路的國際運送選項。',
  },
  {
    question: '三上悠亞有官方粉絲俱樂部嗎？',
    answer: '是的，三上悠亞擁有官方粉絲俱樂部，會員可享有獨家直播、限定周邊商品、優先購票權及專屬生日驚喜等多項福利。詳細資訊請參考官方網站。',
  },
  {
    question: '三上悠亞的生日是什麼時候？',
    answer: '三上悠亞的生日是1993年8月16日，每年這個日子全球粉絲都會發起各種應援活動為她慶生。',
  },
  {
    question: '如何聯繫三上悠亞的經紀團隊？',
    answer: '如需商業合作或媒體採訪，請透過本網站「關於我們」頁面的聯絡表單與我們聯繫，我們將協助轉達您的需求。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqLd)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-800 mb-3">
            常見問題
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            常見問題解答
          </h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}